import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50002 3.66669C4.03978 3.66669 3.66669 4.03978 3.66669 4.50002V11.5C3.66669 11.9603 4.03978 12.3334 4.50002 12.3334H11.5C11.9603 12.3334 12.3334 11.9603 12.3334 11.5V4.50002C12.3334 4.03978 11.9603 3.66669 11.5 3.66669H4.50002ZM2.66669 4.50002C2.66669 3.4875 3.4875 2.66669 4.50002 2.66669H11.5C12.5126 2.66669 13.3334 3.4875 13.3334 4.50002V11.5C13.3334 12.5126 12.5126 13.3334 11.5 13.3334H4.50002C3.4875 13.3334 2.66669 12.5126 2.66669 11.5V4.50002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16669 2.83335C5.44283 2.83335 5.66669 3.05721 5.66669 3.33335V12.6667C5.66669 12.9428 5.44283 13.1667 5.16669 13.1667C4.89054 13.1667 4.66669 12.9428 4.66669 12.6667V3.33335C4.66669 3.05721 4.89054 2.83335 5.16669 2.83335Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8334 2.83335C11.1095 2.83335 11.3334 3.05721 11.3334 3.33335V12.6667C11.3334 12.9428 11.1095 13.1667 10.8334 13.1667C10.5572 13.1667 10.3334 12.9428 10.3334 12.6667V3.33335C10.3334 3.05721 10.5572 2.83335 10.8334 2.83335Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.83335 5.83335C2.83335 5.55721 3.05721 5.33335 3.33335 5.33335H5.00002C5.27616 5.33335 5.50002 5.55721 5.50002 5.83335C5.50002 6.1095 5.27616 6.33335 5.00002 6.33335H3.33335C3.05721 6.33335 2.83335 6.1095 2.83335 5.83335Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8334 5.83335C10.8334 5.55721 11.0572 5.33335 11.3334 5.33335H12.6667C12.9428 5.33335 13.1667 5.55721 13.1667 5.83335C13.1667 6.1095 12.9428 6.33335 12.6667 6.33335H11.3334C11.0572 6.33335 10.8334 6.1095 10.8334 5.83335Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.83335 8.00002C2.83335 7.72388 3.05721 7.50002 3.33335 7.50002H12.6667C12.9428 7.50002 13.1667 7.72388 13.1667 8.00002C13.1667 8.27616 12.9428 8.50002 12.6667 8.50002H3.33335C3.05721 8.50002 2.83335 8.27616 2.83335 8.00002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.83335 10.1667C2.83335 9.89054 3.05721 9.66669 3.33335 9.66669H5.00002C5.27616 9.66669 5.50002 9.89054 5.50002 10.1667C5.50002 10.4428 5.27616 10.6667 5.00002 10.6667H3.33335C3.05721 10.6667 2.83335 10.4428 2.83335 10.1667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8334 10.1667C10.8334 9.89054 11.0572 9.66669 11.3334 9.66669H12.6667C12.9428 9.66669 13.1667 9.89054 13.1667 10.1667C13.1667 10.4428 12.9428 10.6667 12.6667 10.6667H11.3334C11.0572 10.6667 10.8334 10.4428 10.8334 10.1667Z"
      fill="currentColor"
    />
  </SvgIcon>
));
